import { defaultHttpClient } from 'shared/src/api/httpClient';
import { getAnonymousToken, getMemberToken } from 'shared/src/utils';
import type { PostLogParams } from './types';

export const postLog = async ({ clientTime, events }: PostLogParams) => {
  const memberJWTToken = await getMemberToken();
  const anonymouseJWTToken = await getAnonymousToken();

  // https://ablycorp.slack.com/archives/C036PBN2EPR/p1678090786269049
  // 쿠키가 없는 경우 로그를 보내지 않는다.
  if (!memberJWTToken && !anonymouseJWTToken) return;

  return defaultHttpClient.request<void>({
    method: 'POST',
    url: `/api/v2/log/events/`,
    data: {
      client_time: clientTime,
      events,
    },
  });
};
